/**
 * Constants of the generic Uploads service: the endpoints of the upload
 * batches list and of a single batch's details.
 *
 * These endpoints are platform wide and not tied to one feature: a batch
 * carries a `batch_type` telling what produced it, so energy bills are
 * only one of its possible producers.
 */
export abstract class UploadServiceConst {

    /**
     * Shared API prefix for every uploads request.
     * Resolves to: general/uploads
     */
    public static readonly API_PREFIX_ENDPOINT = 'general/uploads';

    /**
     * POST the upload batches list. Takes the standard datatable body.
     * Resolves to: general/uploads
     */
    public static readonly LIST_ENDPOINT = UploadServiceConst.API_PREFIX_ENDPOINT;

    /**
     * GET a single upload batch with its per-file items — the source of an
     * expanded row, since the list can go stale while a batch is still
     * being processed.
     * Resolves to: general/uploads/{batchId}
     *
     * @param batchId - Identifier of the batch to fetch.
     */
    public static readonly DETAILS_ENDPOINT = (batchId: string): string => `${UploadServiceConst.API_PREFIX_ENDPOINT}/${batchId}`;

    /**
     * Column the list is sorted by: newest upload first.
     */
    public static readonly DEFAULT_SORT_COLUMN = 'uploaded_at';

    /**
     * How many batches one page of the list holds.
     */
    public static readonly DEFAULT_PAGE_SIZE = 10;

}
